import styles from './Recipe.module.css'
import Header from './components/Header.js';
import Loader from './components/Loader.js';
import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import background from './assets/img/background.png';
import unknown_meal from './assets/img/unknown_meal.png'
import unknown_step from './assets/img/unknown_step.png'

export default function Recipe() {
    //Объект для работы с URL
    const location = useLocation();

    //Флаг загрузки
    const [loading, setLoading] = useState(false);
    //Заголовок рецепта
    const [title] = useState(new URLSearchParams(location.search).get('title') ? new URLSearchParams(location.search).get('title') : '');
    //Получаемые с бэкенда параметры
    const [recipe, setRecipe] = useState({});
    //Коэффициент использования ингредиентов
    const [ingredientsCoeff, setIngredientsCoeff] = useState(1);

    //Запрашиваем данные с бекенда и устанавливаем заголовок
    /* eslint-disable */
    useEffect(() => {
        document.title = `Рецепт "${title}" - Coperand recipes`;

        //Устанавливаем флаг загрузки
        setLoading(true);

        fetch(`/api/recipe/${title}`, {method: 'GET'})
            .then(response => response.json())
            .then(data => {
                //Сохраняем полученные данные
                if(data !== null)
                    setRecipe(data);
                else
                    alert("Ошибка получения рецепта");

                //Сбрасываем флаг загрузки
                setLoading(false);
            })
            .catch((error) => {
                //Сбрасываем флаг загрузки
                setLoading(false);

                //Выводим информацию об ошибке
                alert("Ошибка получения рецепта");
            });
    }, []);
    /* eslint-enable */

    return (
        <>
            {loading === true && <Loader/>}
            <div className={styles.main_column}>
                <Header/>
                <main className={styles.main} style={{backgroundImage: `url(${background})`}}>
                    <div className={styles.columns_grid}>
                        <div className={styles.left_vertical_flex}>
                            <div className={styles.recipe_card}>
                                <h2 className={styles.recipe_title}>{recipe.title}</h2>
                                <div className={styles.recipe_cover_background}>
                                    <img src={recipe.image && recipe.image.length > 0 ? ('/images/' + recipe.image) : unknown_meal} alt='Обложка рецепта' className={styles.recipe_cover}></img>
                                </div>
                            </div>
                            {recipe.tags && recipe.tags.length > 0 &&
                            <>
                                <h3 className={styles.tags_title}>Теги:</h3>
                                <div className={styles.tags_flex}>
                                    {recipe.tags.map((tag, index) =>
                                        <Link to={`/recipes?tag=${tag}`}><button key={index} className={styles.tag}>{tag}</button></Link>
                                    )}
                                </div>
                            </>
                            }
                            {recipe.ingredients && recipe.ingredients.length > 0 &&
                            <>
                                <div className={styles.ingredients_horizontal_flex}>
                                    <h3 className={styles.ingredients_title}>Ингредиенты:</h3>
                                    <button className={styles.ingredients_control_button} onClick={() => setIngredientsCoeff(ingredientsCoeff > 0.25 ? (ingredientsCoeff - 0.25) : ingredientsCoeff)}>-</button>
                                    <span className={styles.ingredients_control_display}>X{ingredientsCoeff.toFixed(2)}</span>
                                    <button className={styles.ingredients_control_button} onClick={() => setIngredientsCoeff(ingredientsCoeff + 0.25)}>+</button>
                                </div>
                                <ul className={styles.ingredients_unordered_list}>
                                    {recipe.ingredients.map((ingredient, index) =>
                                    <li key={index}>{ingredient.quantity > 0 ? (((ingredient.quantity * ingredientsCoeff) % 1 === 0) ? (ingredient.quantity * ingredientsCoeff) : (ingredient.quantity * ingredientsCoeff).toFixed(2)) : 'по вкусу'}{ingredient.units.length > 0 ? (" " + ingredient.units) : ""} {ingredient.description}</li>
                                    )}
                                </ul>
                            </>
                            }
                            {recipe.steps && recipe.steps.length > 0 &&
                            <>
                                <h3 className={styles.steps_title}>По шагам:</h3>
                                <div className={styles.steps_flex}>
                                    {recipe.steps.map((step, index) =>
                                    <div key={index} className={styles.step_container}>
                                        <img src={step.image.length > 0 ? ('/images/' + step.image) : unknown_step} alt='Изображение шага' className={styles.step_image}></img>
                                        <p className={styles.step_description}>{step.content}</p>
                                    </div>
                                    )}
                                </div>
                            </>
                            }
                        </div>
                        <div className={styles.right_vertical_flex}>
                            <div>
                                {recipe.tags && recipe.tags.length > 0 &&
                                <>
                                    <h3 className={styles.tags_title}>Теги:</h3>
                                    <div className={styles.tags_flex}>
                                        {recipe.tags.map((tag, index) =>
                                            <Link to={`/recipes?tag=${tag}`}><button key={index} className={styles.tag}>{tag}</button></Link>
                                        )}
                                    </div>
                                </>
                                }
                                {recipe.ingredients && recipe.ingredients.length > 0 &&
                                <>
                                    <div className={styles.ingredients_horizontal_flex}>
                                        <h3 className={styles.ingredients_title}>Ингредиенты:</h3>
                                        <button className={styles.ingredients_control_button} onClick={() => setIngredientsCoeff(ingredientsCoeff > 0.25 ? (ingredientsCoeff - 0.25) : ingredientsCoeff)}>-</button>
                                        <span className={styles.ingredients_control_display}>X{ingredientsCoeff.toFixed(2)}</span>
                                        <button className={styles.ingredients_control_button} onClick={() => setIngredientsCoeff(ingredientsCoeff + 0.25)}>+</button>
                                    </div>
                                    <ul className={styles.ingredients_unordered_list}>
                                        {recipe.ingredients.map((ingredient, index) =>
                                        <li key={index}>{ingredient.quantity > 0 ? (((ingredient.quantity * ingredientsCoeff) % 1 === 0) ? (ingredient.quantity * ingredientsCoeff) : (ingredient.quantity * ingredientsCoeff).toFixed(2)) : 'по вкусу'}{ingredient.units.length > 0 ? (" " + ingredient.units) : ""} {ingredient.description}</li>
                                        )}
                                    </ul>
                                </>
                                }
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}
